<script setup lang="ts">
import ActionsTable from './ActionsTable/ActionsTable.vue';
import AddNewActionsModal from './ActionsForm/ActionsFormModal.vue';
import EditStatusModal from './EditStatus/EditStatusModal.vue';
</script>

<template>
  <div>
    <EditStatusModal />
    <AddNewActionsModal />
    <ActionsTable />
  </div>
</template>
